<div class="grid-detail-wrap border bg-white mb-3">
  <div class="row justify-content-between mb-5">
    <div class="col-md-7">
      <h3>Наименование</h3>
      <dx-text-box [(value)]="this.selfDiagnosis.nameUa"></dx-text-box>
    </div>
    <div class="col-md-9">
      <h3>Услуга</h3>
      <dx-select-box
        [dataSource]="this.searchDataSource"
        [(value)]="this.selectedMenuItem"
        displayExpr="nameUa"
        placeholder="{{ 'SEARCH_IT_SERVICE' | translate }}"
        [minSearchLength]="0"
        [searchEnabled]="true"
        [searchTimeout]="500"
        [showClearButton]="true"
        animationEnabled="false"
        id="searchDataSourceId"
        class="search-dx-select-box search-dx-select-box-fullscreen mdi mdi-magnify"
        style="width: 350px; min-width: 350px">
        <div *dxTemplate="let data of 'item'" class="custom-item catalog-photo" style="white-space: pre-wrap">
          <div class="d-flex">
            <div class="me-3">
              @if (data.iconBody) {
                <img
                  style="width: 60px"
                  [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + data.iconType + ';base64,' + data.iconBody)" />
              }
              @if (!data.iconBody) {
                <img style="width: 60px" src="../../../../../assets/images/nophoto.png" />
              }
            </div>
            <div>
              <div>{{ data.nameRu }}</div>
              <div class="category color-black" style="font-size: 80%; color: #091e42">
                {{ data.category.nameRu }}
              </div>
            </div>
          </div>
        </div>
      </dx-select-box>
    </div>
    <div class="col-md-7">
      <h3>Категория запроса</h3>
      <dx-radio-group
        [items]="this.serviceTypes$ | async"
        [(value)]="this.selfDiagnosis.typeId"
        displayExpr="nameRu"
        valueExpr="id"></dx-radio-group>
    </div>
  </div>
  <div class="row justify-content-between mb-3">
    <div class="col-md-7">
      <h3>Приоритет</h3>
      <dx-number-box [(value)]="this.selfDiagnosis.priority" [min]="0" [max]="1000" [showSpinButtons]="true"></dx-number-box>
    </div>
    <div class="col-md-9">
      <h3>Ключевые слова</h3>
      <div class="d-flex mb-3">
        <dx-text-box [(value)]="this.keyWord" class="flex-grow-1 me-2"></dx-text-box>
        <dx-button text="" icon="add" class="btn" (onClick)="this.addKeyWord()"></dx-button>
      </div>
      <div class="d-flex flex-wrap">
        @for (keyWord of this.keyWords; track keyWord) {
          <dx-button
            [text]="keyWord"
            icon="mdi mdi-close-thick"
            (onClick)="this.removeKeyWord(keyWord)"
            class="btn btn-light button-icon-close me-2 mb-2"></dx-button>
        }
      </div>
    </div>
    <div class="col-md-7">
      <h3>Иконка</h3>
      <div class="d-fle">
        <div>
          @if (this.selfDiagnosis.iconBody) {
            <div class="icon rounded border p-3 mb-3 d-inline-block">
              @if (this.selfDiagnosis.iconBody) {
                <img
                  [src]="
                    this.sanitizer.bypassSecurityTrustResourceUrl(
                      'data:' + this.selfDiagnosis.iconType + ';base64,' + this.selfDiagnosis.iconBody
                    )
                  "
                  style="max-width: 50px"
                  class="" />
              }
            </div>
          }
        </div>
        <div class="">
          <dx-button (onClick)="this.uploadIcon(this.selfDiagnosis)" icon="mdi mdi-upload" class="btn me-2" text="Загрузить"></dx-button>
          <dx-button (onClick)="this.deleteIcon(this.selfDiagnosis)" class="btn btn-light" text="Удалить"></dx-button>
        </div>
      </div>
    </div>
  </div>
  <h3>Шаги</h3>
  @if (this.selectedStep) {
    <dx-html-editor [(value)]="this.selectedStep.bodyUa" [height]="500" class="mb-3">
      <dxo-toolbar>
        <dxi-item name="undo"></dxi-item>
        <dxi-item name="redo"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"></dxi-item>
        <dxi-item
          name="font"
          [acceptedValues]="[
            'Arial',
            'Courier New',
            'Georgia',
            'Impact',
            'Lucida Console',
            'Tahoma',
            'Times New Roman',
            'Verdana',
          ]"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="bold"></dxi-item>
        <dxi-item name="italic"></dxi-item>
        <dxi-item name="strike"></dxi-item>
        <dxi-item name="underline"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="alignLeft"></dxi-item>
        <dxi-item name="alignCenter"></dxi-item>
        <dxi-item name="alignRight"></dxi-item>
        <dxi-item name="alignJustify"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="orderedList"></dxi-item>
        <dxi-item name="bulletList"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="header" [acceptedValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="color"></dxi-item>
        <dxi-item name="background"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="link"></dxi-item>
        <dxi-item name="image"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="clear"></dxi-item>
        <dxi-item name="codeBlock"></dxi-item>
        <dxi-item name="blockquote"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="insertTable"></dxi-item>
        <dxi-item name="deleteTable"></dxi-item>
        <dxi-item name="insertRowAbove"></dxi-item>
        <dxi-item name="insertRowBelow"></dxi-item>
        <dxi-item name="deleteRow"></dxi-item>
        <dxi-item name="insertColumnLeft"></dxi-item>
        <dxi-item name="insertColumnRight"></dxi-item>
        <dxi-item name="deleteColumn"></dxi-item>
        <dxi-item name="separator"></dxi-item>
      </dxo-toolbar>
    </dx-html-editor>
  }

  <div class="dx-flex">
    @for (step of this.selfDiagnosis.selfDiagnosisSteps; track step) {
      <dx-button
        [text]="'Шаг ' + step.orderNumber"
        (onClick)="this.selectStep(step.orderNumber)"
        icon=""
        [class]="this.selectedStep.orderNumber == step.orderNumber ? 'btn btn-red me-2' : 'btn btn-snorlax me-2'"></dx-button>
    }
    <dx-button text="" icon="add" class="btn btn-light" (onClick)="this.addStep()"></dx-button>
  </div>
</div>
<dx-button text="{{ 'SAVE' | translate }}" icon="save" class="btn btn-light" (onClick)="this.save()"></dx-button>

<dialog-edit-icon></dialog-edit-icon>
